export default "__VITE_ASSET__DxY7jXtq__"